<template>
  <div class="kr-layout-content">
    <!--左边-->
    <div class="content-left">
      <div class="top-img">
        <img src="../../assets/img/msg.png" alt>最新视频
      </div>
      <!--视频列表-->
      <ul class="act-list video-list">
        <li v-for="(item,index) in content" :key="index" @click="videoDetails(item.id)">
          <div class="act-img">
            <img :src="item.pic" alt>
            <i class="iconfont icon-shipin"></i>
            <span class="video-time-length">{{item.videoDuration}}</span>
          </div>
          <div class="act-cont">
            <p class="title twoline">{{item.title}}</p>
            <p class="art twoline">{{item.content}}</p>
            <div class="source">
              <div class="author-img">
                <img :src="item.userHeadPic">
              </div>
              <div class="cont">
                <span class="nick">{{item.userName }}</span>
                <span class="zan">
                  <i class="iconfont icon-zhuanfa1"></i>
                </span>
                <span class="zan">
                  <i class="iconfont icon-pinglun"></i>
                  {{item.commentNum}}
                </span>
                <span class="zan">
                  <i class="iconfont icon-zan"></i>
                  {{item.zanNum}}
                </span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="loadmore" class="look-more" @click="newsMore">查看更多</div>
      <p v-if="!loadmore" class="none-more">没有更多了</p>
    </div>
    <!--右边-->
    <div class="content-right">
      <div class="top-img">
        <img src="../../assets/img/msg.png" alt>推荐作者
      </div>
      <ul class="author-list">
        <li v-for="(item,index) in recom" :key="index" @click="author(item.id)">
          <div class="author-img">
            <img :src="item.pic">
          </div>
          <div class="cont">
            <p class="nick">{{item.nickName}}</p>
            <p class="email">{{item.des}}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  //   name: "App",
  data() {
    return {
      content: [],
      recom: [],
      loadmore:true,
      curPage: 1,
      totalPage: 0,
    };
  },
  methods: {
    getVideo() {
      //获取视频列表
      this.$http
        .get("/api/core/002--newsList", {
          params: {
            type: 2,
            pageNo: this.curPage
          }
        })
        .then(res => {
          // console.log(res, "视频页列表");
          if (res.status == 200 && res.data.code == 0) {
            this.content = this.content.concat(res.data.rows);
            if (this.curPage >= res.data.totalPage ) {
              this.loadmore = false;
            }
            this.curPage++;
          }
        });
    },
    newsMore() {  //查看更多
      this.getVideo();
    },
    getRecom() { //推荐作者
      this.$http
        .get("/api/core/019-hotAuthor", {
          params: {
            type: 2,
            limit: 10
          }
        })
        .then(res => {
          console.log(res, "推荐列表");
          if (res.status == 200 && res.data.code == 0) {
            this.recom = res.data.rows;
          }
        });
    },
    videoDetails(id) {
      //视频详情
      this.$router.push({ path: "/vdDetails", query: { id: id, type: 2 } });
    },
    author(id) {
      //作者个人主页
      this.$router.push({ path: "/personal", query: { id: id, type: 3 } });
    }
  },
  mounted() {
    this.getVideo();
    this.getRecom();
  }
};
</script>
<style scoped>
.new-article .art-list li .content .author .name {
  padding-left: 0px;
}
.top-img {
  margin-top: 0px;
}
.look-more {
  margin: 60px auto;
}
.icon-shipin {
  font-size: 40px;
}
</style>